<template>
    <div>
        <van-loading class="tip" v-if="loading"/>
        <div v-else>
            <div v-if="success" class="tip">
                <van-icon name="passed" color="green" size="60"/>
                <h4>绑定成功 </h4>
                <van-button  type="primary" block @click="goHome">回首页</van-button>
            </div>
            <div v-else class="tip">
                <van-icon name="close" color="red" size="60"/>
                <h4>{{tip}}</h4>
                <van-button  type="primary" block @click="goHome">回首页</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {bindUser} from '../../api/user-bind'

    export default {
        name: "tip",
        data() {
            return {
                loading: true,
                success: false,
                tip: '绑定失败'
            }
        },
        async mounted() {
            this.loading = true
            let urlSearchParams = new URLSearchParams(window.location.search);
            let code = urlSearchParams.get('code');
            bindUser(code).then(() => {
                this.loading = false
                this.success = true
            }).catch(e => {
                this.loading = false
                this.success = false
                this.tip = e
            })
        },
        methods:{
            goHome(){
                this.$router.push({name:'home'})
            }
        }
    }
</script>

<style scoped>
.tip{
    padding: 30px;
    text-align: center;
}
</style>
